import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import { getUserDocsAPI } from '../../utils/apisConsts';
import ApproveDocs from './approveDocs';

class ApproveUserDocs extends Component {
    state = {
        componentSteps: [
            {
                title: 'Get User Documents',
                content: <GetInfo apiLink={getUserDocsAPI} />,
                id: 0,
            }, {
                title: 'Approve Documents',
                content: <ApproveDocs />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default ApproveUserDocs